import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';

import { getBankdetal, Property, ReserAgentDynamicVoucher, ReserBookingCancle, ReserCancelReason, ReserDynamicVoucher, ReservationBookinglist, ReserVoucherSend } from '../../Services/Service';

import swal from "sweetalert";
import { useProperty } from '../../PropertyContext';
import ReservationSidebar from '../Commun/ReservationSidebar';
import ReservationHeader from '../Commun/ReservationHeader';
import { resetPMSState, updatePMS } from '../../Redux/Slices/reserPmsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVoucherDetails } from '../../Redux/Slices/reservationVoucherSlice';
import './BookingList.css';
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { Button } from "primereact/button";
// import { Menu } from "primereact/menu";
// import { useRef } from "react";


const ReserBookingList = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [bookingloading, setBookingLoading] = useState(false);
    const location = useLocation();
    const [showSuccess, setShowSuccess] = useState(false);
    const [bookingData, setBookingData] = useState([]);

    const [cancelCodes, setCancelCodes] = useState([]);
    const [selectedCode, setSelectedCode] = useState("");
    const [cancelReason, setCancelReason] = useState("");
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [, setBankFormData] = useState(null);
    const [emails, setEmails] = useState([]);
    const [inputEmail, setInputEmail] = useState("");
    const [error, setError] = useState("");
    const [Pms, setPMS] = useState();
    const [filters, setFilters] = useState({
        BookingDate: "",
        GuestName: "",
        CheckInDate: "",
        CheckOutDate: "",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;

    // const actionMenu = useRef(null);

    const { loading: pmsLoading, success } = useSelector((state) => state.pms);

    const [pmsId, setPmsId] = useState("");

    useEffect(() => {
        const fetchBookings = async () => {
            setBookingLoading(true);
            try {
                const data = await ReservationBookinglist({ propertyID: selectedProperty.PropertyID });
                setBookingData((data || []));
                setCurrentPage(1);
            } catch (error) {
                console.log("Error fetching bookings", error);
            } finally {
                setBookingLoading(false);
            }
        };
        fetchBookings();
    }, [selectedProperty])


    const handleFilter = async () => {
        setLoading(true);
        try {
            const data = await ReservationBookinglist({
                propertyID: selectedProperty.PropertyID,
                BookingDate: filters.BookingDate,
                GuestName: filters.GuestName,
                CheckInDate: filters.CheckInDate,
                CheckOutDate: filters.CheckOutDate,
            });

            setBookingData((data || []));
            setCurrentPage(1);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    const handleClear = async () => {
        setFilters({
            BookingDate: "",
            GuestName: "",
            CheckInDate: "",
            CheckOutDate: "",
        });

        // if (window.$.fn.DataTable.isDataTable(".basic-datatables")) {
        //     window.$(".basic-datatables").DataTable().destroy();
        // }

        const data = await ReservationBookinglist({
            propertyID: selectedProperty.PropertyID,
        });
        setBookingData((data || []));
        setCurrentPage(1);
    };



    useEffect(() => {
        if (location.state?.showSuccess) {
            setShowSuccess(true);

            const timer = setTimeout(() => {
                setShowSuccess(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [location.state]);

    useEffect(() => {
        const getBankdetails = async () => {
            setLoading(true);
            try {
                const result = await getBankdetal();
                if (result && result.length > 0) {
                    setBankFormData(result[0]);
                }
            }
            catch (error) {
                console.log("error get bank details", error);
            } finally {
                setLoading(false);
            }
        }
        getBankdetails();
    }, []);


    const handleGenerateVoucher = async (bonResId) => {
        try {
            setLoading(true);

            const data = await ReserDynamicVoucher(
                bonResId,
                selectedProperty?.PropertyID
            );

            const url = data?.url;

            if (!url) {
                alert("Voucher URL not found");
                return;
            }

            // console.log("Voucher URL:", url);

            // 👉 Open in new tab (_blank)
            window.open(url, "_blank");

        } catch (error) {
            console.error("Voucher open failed:", error);
            alert("Failed to open voucher");
        } finally {
            setLoading(false);
        }
    };


    const handleAgentGenerateVoucher = async (bonResId) => {
        try {
            setLoading(true);

            const data = await ReserAgentDynamicVoucher(
                bonResId,
                selectedProperty?.PropertyID
            );

            const url = data?.url;

            if (!url) {
                alert("Voucher URL not found");
                return;
            }

            // console.log("Voucher URL:", url);

            // 👉 Open in new tab (_blank)
            window.open(url, "_blank");

        } catch (error) {
            console.error("Voucher open failed:", error);
            alert("Failed to open voucher");
        } finally {
            setLoading(false);
        }
    };

    // Booking Cancel reason Function
    useEffect(() => {
        const fetchCancelReason = async () => {
            try {
                const result = await ReserCancelReason(selectedProperty?.PropertyID);
                setCancelCodes(result || []);
            }
            catch (error) {
                console.log("error fetching cancel resons in Booking list page", error);
            }
        }
        fetchCancelReason();
    }, [selectedProperty]);

    const handleCodeChange = (e) => {
        const code = e.target.value;
        setSelectedCode(code);

        const selected = cancelCodes.find((c) => c.Code === code);
        if (selected) {
            setCancelReason(selected.Description);
        } else {
            setCancelReason("");
        }
    };

    // reset form
    const resetCancelForm = () => {
        setSelectedCode("");
        setCancelReason("");
        setSelectedBooking(null);
    };

    // booking cancle
    const handleCancelBooking = async (item) => {

        if (!selectedCode) {
            alert("Please select a cancellation code.");
            return;
        }

        if (!cancelReason) {
            alert("Please enter a reason.");
            return;
        }

        setLoading(true);
        try {
            const result = await ReserBookingCancle(item.BONRESID, selectedProperty?.PropertyID, selectedCode, cancelReason);

            if (result && result.BONRESID) {
                swal("Booking Cancelled Successfully", {
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-success",
                        },
                    },
                }).then(() => {

                    const modal = window.bootstrap.Modal.getInstance(
                        document.getElementById("Cancel-Booking-Resion")
                    );
                    if (modal) modal.hide();

                    resetCancelForm(); // reset fields
                });

                // Table update: remove cancelled booking ya fetch list again
                setBookingData((prev) =>
                    prev.map((b) =>
                        b.BONRESID === item.BONRESID ? { ...b, BookingStatus: "Cancelled" } : b
                    )
                );

            } else {
                alert(result?.message || "Failed to cancel booking");
            }
        } catch (error) {
            console.error(error);
            alert("Error cancelling booking");
        } finally {
            setLoading(false);
        }

    };


    const isValidEmail = (value) => {
        const email = value.trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const addEmail = (value) => {
        if (!value) return false;

        const parts = value
            .split(/[\s,;]+/)
            .map(p => p.trim())
            .filter(Boolean);

        let addedAny = false;

        for (let p of parts) {
            if (!isValidEmail(p)) {
                setError(`Invalid email: ${p}`);
                return false;
            }
            if (!emails.includes(p)) {
                setEmails(prev => [...prev, p]);
                addedAny = true;
            }
        }

        setInputEmail("");
        setError("");
        return addedAny;
    };

    const removeEmail = (emailToRemove) => {
        setEmails(prev => prev.filter(e => e !== emailToRemove));
    };

    const editEmail = (emailToEdit) => {
        setInputEmail(emailToEdit);
        setEmails(prev => prev.filter(e => e !== emailToEdit));
    };

    const handlePaste = (e) => {
        const paste = e.clipboardData.getData("text");
        if (paste && /[,;\s]/.test(paste)) {
            e.preventDefault();
            addEmail(paste);
        }
    };


    const handleSendVoucher = async () => {
        if (!selectedBooking) {
            alert("No booking selected!");
            return;
        }

        // Single email auto add
        if (inputEmail) {
            const added = addEmail(inputEmail);
            if (!added) return;
        }

        if (emails.length === 0) {
            alert("Please enter at least one email!");
            return;
        }

        const id = selectedBooking.BONRESID;
        const EmailID = emails.join(",");
        const PropID = selectedProperty?.PropertyID;

        try {
            setLoading(true);
            const response = await ReserVoucherSend(id, EmailID, PropID);

            if (response?.url) {
                alert("Voucher Sent Successfully");

                const modalEl = document.getElementById("zoomInModal");
                const modal =
                    window.bootstrap.Modal.getInstance(modalEl) ||
                    new window.bootstrap.Modal(modalEl);
                modal.hide();

                setEmails([]);
                setInputEmail("");
            } else {
                alert("Failed to send voucher!");
            }
        } catch (err) {
            console.error(err);
            alert("Failed to send voucher!");
        } finally {
            setLoading(false);
        }
    };


    const handleUpdatePMS = () => {
        if (!pmsId) {
            alert("Please enter PMS ID");
            return;
        }

        if (!selectedBooking) {
            alert("No booking selected");
            return;
        }

        dispatch(
            updatePMS({
                PID: selectedProperty.PropertyID,
                BONRESID: selectedBooking.BONRESID,
                PMSRESID: pmsId,
            })

        );
    };

    useEffect(() => {
        if (success) {
            swal("PMS Update Successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                // modal close
                const modalEl = document.getElementById("UpdatePMS");
                const modal =
                    window.bootstrap.Modal.getInstance(modalEl) ||
                    new window.bootstrap.Modal(modalEl);

                modal.hide();

                setPmsId("");

                // table update
                setBookingData((prev) =>
                    prev.map((b) =>
                        b.BONRESID === selectedBooking.BONRESID
                            ? { ...b, PMSRESID: pmsId }
                            : b
                    )
                );

                dispatch(resetPMSState());
            });
        }

        if (error) {
            alert(error);
            dispatch(resetPMSState());
        }
    }, [success, dispatch, pmsId, selectedBooking, error]);



    const handleModify = async (item) => {
        const result = await dispatch(fetchVoucherDetails(item.BONRESID));

        if (fetchVoucherDetails.fulfilled.match(result)) {
            const data = result.payload;
            navigate('/Reservation/EditBookingList', {
                state: {
                    header: data.Table?.[0],
                    rooms: data.Table1,
                    bookingInfo: data.Table4?.[0],
                }
            });
        }
    };


    const handleOperaModify = async (item) => {
        const result = await dispatch(fetchVoucherDetails(item.BONRESID));

        if (fetchVoucherDetails.fulfilled.match(result)) {
            const data = result.payload;
            navigate('/Reservation/EditBooking', {
                state: {
                    header: data.Table?.[0],
                    rooms: data.Table1,
                    bookingInfo: data.Table4?.[0],
                }
            });
        }
    };


    useEffect(() => {
        const FetchPMS = async () => {
            if (!selectedProperty?.PropertyID) return;

            try {
                const result = await Property();
                const matched = result.find(
                    p => p.PropertyID === selectedProperty.PropertyID
                );
                setPMS(matched || null);
            } catch (error) {
                console.log("error fetch PMS", error);
            }
        };
        FetchPMS();
    }, [selectedProperty]);


    const totalRows = bookingData.length;
    const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
    const safeCurrentPage = Math.min(currentPage, totalPages);
    const firstRow = totalRows === 0 ? 0 : ((safeCurrentPage - 1) * rowsPerPage) + 1;
    const lastRow = Math.min(safeCurrentPage * rowsPerPage, totalRows);
    const visibleBookings = bookingData.slice(firstRow ? firstRow - 1 : 0, lastRow);
    const pageStart = Math.min(
        Math.max(safeCurrentPage - 1, 1),
        Math.max(totalPages - 2, 1)
    );
    const visiblePages = Array.from(
        { length: Math.min(3, totalPages) },
        (_, index) => pageStart + index
    );

    return (
        <>
            <style>{`
         
        tr th{
           font-size: 12px !important;
        }
           label{
             font-weight:bold !important;
           }

           .booking-filter-form .card-body .d-flex > div {
            flex: 0 0 auto;
            max-width: none;
          }

      @media (max-width: 768px) {
        .booking-filter-form .card-body .d-flex {
          flex-wrap: wrap;
          gap: 0.75rem;
          align-items: flex-start;
        }

  .booking-filter-form .card-body .d-flex > div {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .booking-filter-form .card-body .d-flex > div .btn {
    min-width: 110px;    
  }

  @media (max-width: 420px) {
    .booking-filter-form .card-body .d-flex > div:last-child {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .booking-filter-form .card-body .d-flex > div:last-child .btn {
      width: 100%;
      min-width: unset;
    }
  }

  .booking-filter-form .card-body .form-label {
    font-size: 0.92rem;
  }
}

.booking-filter-form .card-body .form-control {
  box-sizing: border-box;
  width: 100%;
}

.badge {    
    margin-left: initial;
      }

       ul {
    padding-left: 0; 
}

.p-menu {
    min-width: 180px;
}

.p-menu .p-menuitem-link {
    display: flex;
    align-items: center;
    padding: 10px 14px;
}

.p-menu .p-menuitem-link:hover {
    background-color: #f8f9fa;
    color: #4b5563;
}

.custom-menu-item {
    color: #4b5563;
    text-decoration: none;
}

.p-menu .p-menuitem-link {
    display: flex;
    align-items: center;
    padding: 10px 14px;
    text-decoration: none;
    color: #212529;
}

.p-menu .p-menuitem-link:hover {
    background-color: #f8f9fa;
}

    `}</style>

            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            {bookingloading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            {pmsLoading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className='booking-filter-form card mb-3'>

                                        <form className="card-body">
                                            <div className='booking-filter-grid'>
                                                <div className="booking-filter-field">
                                                    <label className='form-label'>Booking Date</label>
                                                    <input
                                                        className='form-control'
                                                        type='date'
                                                        value={filters.BookingDate}
                                                        onChange={(e) =>
                                                            setFilters({ ...filters, BookingDate: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="booking-filter-field">
                                                    <label className='form-label'>Guest Name</label>
                                                    <input
                                                        className='form-control'
                                                        type='text'
                                                        placeholder='Enter Guest name'
                                                        value={filters.GuestName}
                                                        onChange={(e) =>
                                                            setFilters({ ...filters, GuestName: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="booking-filter-field">
                                                    <label className='form-label'>Company name</label>
                                                    <input className='form-control' type='text' placeholder='Enter Company name' />
                                                </div>

                                                <div className="booking-filter-field">
                                                    <label className='form-label'>Check-In</label>
                                                    <input
                                                        className='form-control'
                                                        type='date'
                                                        value={filters.CheckInDate}
                                                        onChange={(e) =>
                                                            setFilters({ ...filters, CheckInDate: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="booking-filter-field">
                                                    <label className='form-label'>Check-Out</label>
                                                    <input
                                                        className='form-control'
                                                        type='date'
                                                        value={filters.CheckOutDate}
                                                        onChange={(e) =>
                                                            setFilters({ ...filters, CheckOutDate: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className='booking-filter-actions'>
                                                    <button
                                                        className='btn btn-outline-danger'
                                                        type='button'
                                                        onClick={handleClear}
                                                    >
                                                        Clear
                                                    </button>

                                                    <button
                                                        className='btn btn-primary'
                                                        type='button'
                                                        onClick={handleFilter}
                                                    >
                                                        Filter Results
                                                    </button>
                                                </div>
                                            </div>
                                        </form>

                                    </div>


                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>Your booking details submitted to Hotel!</div>
                                        </div>
                                    )}


                                    <div className="card booking-list-card">
                                        <div className="card-header booking-list-header">
                                            <h4 className="card-title mb-0">Booking List</h4>

                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive booking-list-table-wrap">
                                                <table
                                                    className="display table  table-bordered table-striped table-hover basic-datatables"
                                                    style={{ tableLayout: "fixed" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width:"4%"}}>Sr#</th>
                                                            <th style={{width:"10%"}}>BON REF. Id</th>
                                                            <th style={{width:"10%"}}>Conf. No</th>
                                                            <th style={{width:"8%"}}>Check-in</th>
                                                            <th style={{width:"8%"}}>Check-out</th>
                                                            <th style={{width:"20%"}}>Guest Info</th>
                                                            <th style={{width:"12%"}}>Mobile No</th>
                                                            <th style={{width:"8%"}}>Payment</th>
                                                            <th style={{width:"8%"}}>Status</th>
                                                            <th style={{width:"9%"}}>Book On</th>
                                                            <th style={{width:"3%"}}>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {visibleBookings.map((item, index) => (
                                                            <tr key={item.ID}>
                                                                <td>{firstRow + index}</td>
                                                                <td className="booking-reference">{item.BONRESID}</td>
                                                                <td>{item.PMSRESID}</td>
                                                                <td>{item.CheckInDate}</td>
                                                                <td> {item.CheckOutDate}</td>
                                                                <td>
                                                                    <b>{item.GuestName}</b>
                                                                    <div>{item.CompanyName}</div>
                                                                    <div>Email: {(() => {
                                                                        try {
                                                                            const gd = JSON.parse(item.GuestDetails);
                                                                            return gd?.[0]?.EMailAddress || "N/A";
                                                                        } catch {
                                                                            return "N/A";
                                                                        }
                                                                    })()}</div>
                                                                </td>
                                                                <td>
                                                                    {(() => {
                                                                        try {
                                                                            const gd = JSON.parse(item.GuestDetails);
                                                                            return gd?.[0]?.MobileNumber || "N/A";
                                                                        } catch {
                                                                            return "N/A";
                                                                        }
                                                                    })()}
                                                                </td>

                                                                <td>
                                                                    <div> <span > ₹ {item.TotalPayment} </span></div>
                                                                    <div>
                                                                        <span
                                                                            className={
                                                                                item.PaymentStatus === "Paid"
                                                                                    ? "text-success"
                                                                                    : item.PaymentStatus === "Pending"
                                                                                        ? "text-warning"
                                                                                        : "text-secondary"
                                                                            }
                                                                        >
                                                                            {item.PaymentStatus || "N/A"}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className="text-center">
                                                                    <span
                                                                        className={
                                                                            item.BookingStatus === "Confirmed"
                                                                                ? "text-success"
                                                                                : item.BookingStatus === "Pending"
                                                                                    ? "text-warning"
                                                                                    : item.BookingStatus === "Cancelled"
                                                                                        ? "text-danger"
                                                                                        : "text-secondary"
                                                                        }
                                                                    >
                                                                        {item.BookingStatus || "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>{item.BookingDate}</td>
                                                                <td className="text-center">
                                                                    <div className="dropdown dropdown-action position-absolute">
                                                                        <a href="/" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                            <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right" >

                                                                            {item.BookingStatus !== "Cancelled" && item.BookingStatus !== "Pending" && (

                                                                                <button type="button" className="dropdown-item" data-bs-toggle="modal"
                                                                                    data-bs-target="#Cancel-Booking-Resion" onClick={() => {
                                                                                        setSelectedBooking(item); setSelectedCode("");
                                                                                        setCancelReason("");
                                                                                    }} ><i className='fas fa-ban me-2'></i>Cancelled</button>
                                                                            )}

                                                                            {Pms?.PMS === "Opera" && (<NavLink to='/Reservation/EditBooking' className="dropdown-item" onClick={() => handleOperaModify(item)} ><i className='fas fa-edit me-1'></i> Modify</NavLink>)}
                                                                            {Pms?.PMS === "IdsNext" && (<NavLink to='/Reservation/EditBookingList' className="dropdown-item" onClick={() => handleModify(item)} ><i className='fas fa-edit me-1'></i> Modify </NavLink>)}
                                                                            <button className="dropdown-item" onClick={() => handleGenerateVoucher(item.BONRESID)}> <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button>
                                                                            <button className="dropdown-item" onClick={() => handleAgentGenerateVoucher(item.BONRESID)}> <i className="fas fa-sticky-note me-2"></i> Agent Booking Voucher </button>
                                                                            <button type="button" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#zoomInModal" onClick={() => setSelectedBooking(item)}><i className='fas fa-envelope me-2'></i>Send Voucher</button>
                                                                            <NavLink to={`/Reservation/VoucherDetail/${item.BONRESID}`} type='button' className="dropdown-item"><i className="fa fa-info-circle me-2"></i>Voucher Details</NavLink>
                                                                            {item.BookingStatus === "Pending" && (<button type="button" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#UpdatePMS" onClick={() => {
                                                                                setSelectedBooking(item);
                                                                                setPmsId("");
                                                                            }}><i className='fas fa-envelope me-2'></i>Update PMS ID</button>)}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </div>
                                            <div className="booking-pagination">
                                                <span>
                                                    Showing {firstRow} to {lastRow} of {totalRows} entries
                                                </span>
                                                <nav aria-label="Booking list pagination">
                                                    <button
                                                        type="button"
                                                        aria-label="Previous page"
                                                        disabled={safeCurrentPage === 1}
                                                        onClick={() => setCurrentPage(page => Math.max(1, page - 1))}
                                                    >
                                                        ‹
                                                    </button>
                                                    {visiblePages.map(page => (
                                                        <button
                                                            type="button"
                                                            key={page}
                                                            className={page === safeCurrentPage ? "active" : ""}
                                                            aria-current={page === safeCurrentPage ? "page" : undefined}
                                                            onClick={() => setCurrentPage(page)}
                                                        >
                                                            {page}
                                                        </button>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        aria-label="Next page"
                                                        disabled={safeCurrentPage === totalPages}
                                                        onClick={() => setCurrentPage(page => Math.min(totalPages, page + 1))}
                                                    >
                                                        ›
                                                    </button>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="modal fade"
                        id="Cancel-Booking-Resion"
                        tabIndex={-1}
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="exampleModalLabel">
                                        Booking Cancel
                                    </h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">

                                    <div className="mb-3">
                                        <label className="col-form-label">Code:</label>
                                        <select className="form-control form-select" value={selectedCode}
                                            onChange={handleCodeChange}>
                                            <option>Select Code</option>
                                            {cancelCodes.map((c) => (
                                                <option key={c.Code} value={c.Code}>
                                                    {c.Code}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="" className="col-form-label">
                                            Cancel Reason:
                                        </label>
                                        <textarea className="form-control" value={cancelReason}
                                            onChange={(e) => setCancelReason(e.target.value)} />
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" onClick={() => handleCancelBooking(selectedBooking)} className="btn btn-danger">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        {/* Modal Blur */}
                        <div
                            id="zoomInModal"
                            className="modal fade zoomIn"
                            tabIndex={-1}
                            aria-labelledby="zoomInModalLabel"
                            aria-hidden="true"
                            style={{ display: "none" }}
                        >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="zoomInModalLabel">
                                            Send Voucher
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-12">
                                                {/* inside your modal-body */}
                                                <div className="email-input-wrapper form-control d-flex gap-1 flex-wrap" style={{ minHeight: "42px" }}>
                                                    {emails.map((email, index) => (
                                                        <span
                                                            key={index}
                                                            className="badge bg-primary align-items-center"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => editEmail(email)}
                                                            title="Click to edit"
                                                        >
                                                            {email}
                                                            <button
                                                                className="btn-close btn-close-white ms-2"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    removeEmail(email);
                                                                }}
                                                            />
                                                        </span>
                                                    ))}

                                                    <input
                                                        type="text"
                                                        value={inputEmail}
                                                        onChange={(e) => { setInputEmail(e.target.value); if (error) setError(""); }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " " || e.key === ",") {
                                                                e.preventDefault(); // form submit / space add hone se rokta hai

                                                                if (inputEmail.trim()) {
                                                                    addEmail(inputEmail.trim());
                                                                }
                                                            }
                                                        }}
                                                        onPaste={handlePaste}
                                                        placeholder={emails.length === 0 ? "Enter Email Address" : ""}
                                                        className="border-0 "
                                                        style={{ outline: "none", minWidth: "200px" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-warning"
                                            onClick={() => inputEmail && addEmail(inputEmail)}
                                        >
                                            Add More
                                        </button>

                                        <button type="button" className="btn btn-primary" onClick={handleSendVoucher}>
                                            Send
                                        </button>
                                    </div>
                                </div>
                                {/* /.modal-content */}
                            </div>
                            {/* /.modal-dialog */}
                        </div>
                        {/* /.modal */}
                    </>

                    <>
                        {/*PMS Modal Blur */}
                        <div
                            id="UpdatePMS"
                            className="modal fade zoomIn"
                            tabIndex={-1}
                            aria-labelledby="zoomInModalLabel"
                            aria-hidden="true"
                            style={{ display: "none" }}
                        >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="zoomInModalLabel">
                                            Update PMS
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <input type="text" className="form-control" placeholder='Enter...' value={pmsId} onChange={(e) => setPmsId(e.target.value)} />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary" onClick={handleUpdatePMS}>
                                            Send
                                        </button>
                                    </div>
                                </div>
                                {/* /.modal-content */}
                            </div>
                            {/* /.modal-dialog */}
                        </div>
                        {/* /.modal */}
                    </>


                </div>

            </div>

        </>
    );
};

export default ReserBookingList;
